module.exports = __webpack_public_path__ + "static/media/melissa.97b3b863.jpg";